import { useState, useEffect, memo } from "react";
import LanguageMessage from "../LanguageMessage/LanguageMessage";
import "./step-progress.scss";
const StepProgress = ({ active, setLocalStorage }) => {
  const [state, setState] = useState(active);
  useEffect(() => {
    setState(active);
  }, [active]);
  const handleClick = (event, value) => {
    event.stopPropagation();
    setState(value);
    setLocalStorage({ optimization: value }, true);
  };
  return (
    <section
      className={`step-progress ${state} d-flex align-items-center
       justify-content-center bg-primary position-relative overflow-hidden rounded-2 transition`}
    >
      <div
        className="line d-flex align-items-center justify-content-center overflow-hidden 
      position-relative bg-secondary rounded-1 w-100 text-center "
      >
        <div
          className="low text-primary"
          onClick={(event) => handleClick(event, "low")}
        >
          <LanguageMessage message="low" />
        </div>
        <div className="space-container d-flex align-items-center flex-column justify-content-between h-100">
          <div className="w-100 bg-primary"></div>
          <div className="w-100 bg-primary"></div>
        </div>
        <div
          className="medium text-primary"
          onClick={(event) => handleClick(event, "medium")}
        >
          <LanguageMessage message="medium" />
        </div>
        <div className="space-container d-flex align-items-center flex-column justify-content-between h-100">
          <div className="w-100 bg-primary"></div>
          <div className="w-100 bg-primary"></div>
        </div>
        <div
          className="high text-primary"
          onClick={(event) => handleClick(event, "high")}
        >
          <LanguageMessage message="high" />
        </div>
        <div className="green-line bg-tertiary w-100 h-100 position-absolute transition"></div>
      </div>
    </section>
  );
};
export default memo(StepProgress);
